module.exports = __webpack_public_path__ + "img/unit.0a8ae089.png";